<div class="sb" [@.disabled]="animDisabled">
  <!-- dev2-only visual-review fixture label -->
  <div class="sb-fixture" *ngIf="fixtureMode">Fixture data for visual review</div>

  <!-- CONTEXT — breadcrumb + what was searched. The primary search now lives in
       the header (nav shell); alternative search modes live in the Search mega
       menu, so the old quick-pick chip row is gone. A REDUCED in-page search is
       kept for now (smaller than the old hero) so we can compare it against the
       header search before deciding whether to drop it. -->
  <div class="sb-context">
    <nav class="sb-crumb" aria-label="Breadcrumb">
      <a href="javascript:void(0)" (click)="goCollection('/')">Home</a>
      <span class="sb-crumb-sep" aria-hidden="true">›</span>
      <a href="javascript:void(0)" (click)="goCollection('/buy')">Search</a>
    </nav>

    <!-- heading + recent searches share a row on desktop; recent collapses
         below the heading on mobile (see stylesheet). -->
    <div class="sb-heading-row">
      <h1 class="sb-heading">Results for &ldquo;{{ termUpper }}&rdquo;</h1>
      <div class="sb-recent" *ngIf="recentChips.length">
        <span class="sb-recent-l">Recent</span>
        <a class="sb-recent-pill" *ngFor="let r of recentChips" href="javascript:void(0)" (click)="goSearch(r)">{{ r }}</a>
      </div>
    </div>

    <!-- reduced in-page refine search (kept for visual comparison) -->
    <div class="sb-search sb-search--compact">
      <div class="sb-search-pill">
        <pla-new-search-input
          [defaultInput]="term"
          [searchTrigger]="searchTrigger"
          [internalRouting]="true"
        ></pla-new-search-input>
        <button class="sb-search-go" (click)="searchTrigger.emit()" aria-label="Search">
          <mat-icon data-nosnippet>&#xe8b6;</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- 6. jump tabs — the sections are STACKED down the page; these buttons scroll
       to the matching section rather than swapping content. Close + Market
       Performance always; the prod-style middle tabs appear when populated. -->
  <div class="sb-tabs sb-tabs--sticky">
    <button class="sb-tab" *ngFor="let t of visibleTabs"
      [class.is-active]="activeTab === t.key"
      [class.sb-tab--market]="t.key === 'market'" (click)="setTab(t.key)">
      {{ t.label }}<span class="sb-tab-c" *ngIf="t.count != null">{{ t.count | number }}</span>
    </button>
  </div>

  <!-- Result view: the stacked list sections (Close / Similar / New / Current /
       Prefix) plus their control band. Market Performance is a separate swap-tab
       (below), so these are hidden while that tab is active. -->
  <ng-container *ngIf="resultsView">

  <!-- CONTROL AREA — one calm band: result count (left) · Save search · Sort ·
       Filter (right). Applies to every stacked list section below. -->
  <div class="sb-filterbar">
    <div class="sb-summary" [innerHTML]="summaryHtml"></div>
    <div class="sb-controls">
    <!-- save this search -->
    <button class="sb-save" type="button" [class.is-saved]="saved" (click)="onSaveSearch()">
      <mat-icon class="sb-save-ic" data-nosnippet *ngIf="!saved">&#xe7f5;</mat-icon>
      <mat-icon class="sb-save-ic" data-nosnippet *ngIf="saved">&#xe7f6;</mat-icon>{{ saved ? 'Saved' : 'Save search' }}
    </button>
    <!-- sort dropdown -->
    <div class="sb-sort-wrap" #sortWrap>
      <button class="sb-sort-btn" type="button"
        [class.is-open]="sortOpen" [class.has-active]="sortMode !== 'relevant'"
        (click)="toggleSort($event)">
        <mat-icon class="sb-sort-ic" data-nosnippet>&#xe8d5;</mat-icon>{{ sortLabel }}
        <mat-icon class="sb-sort-caret" data-nosnippet>&#xe5cf;</mat-icon>
      </button>
      <div class="sb-sort-panel" *ngIf="sortOpen">
        <button class="sb-sort-opt" type="button" [class.on]="sortMode === 'relevant'" (click)="setSort('relevant')">
          <span class="sb-sort-radio" aria-hidden="true"></span>Most Relevant
        </button>
        <button class="sb-sort-opt" type="button" [class.on]="sortMode === 'low'" (click)="setSort('low')">
          <span class="sb-sort-radio" aria-hidden="true"></span>Price Low to High
        </button>
        <button class="sb-sort-opt" type="button" [class.on]="sortMode === 'high'" (click)="setSort('high')">
          <span class="sb-sort-radio" aria-hidden="true"></span>Price High to Low
        </button>
      </div>
    </div>

    <div class="sb-filter-wrap" #filterWrap>
      <button class="sb-filter-btn" type="button"
        [class.is-open]="filterOpen" [class.has-active]="hasActiveFilters"
        (click)="toggleFilter($event)">
        <mat-icon class="sb-filter-ic" data-nosnippet>&#xe152;</mat-icon>Filter
      </button>

      <!-- filter dropdown panel -->
      <div class="sb-filter-panel" *ngIf="filterOpen">
        <div class="sb-fgroup">
          <div class="sb-fglabel">Plate type</div>
          <div class="sb-fopts">
            <button class="sb-fopt" [class.on]="typeFilter === 'dateless'" (click)="setType('dateless')">Dateless</button>
            <button class="sb-fopt" [class.on]="typeFilter === 'current'" (click)="setType('current')">Current</button>
            <button class="sb-fopt" [class.on]="typeFilter === 'prefix'" (click)="setType('prefix')">Prefix</button>
            <button class="sb-fopt" [class.on]="typeFilter === 'suffix'" (click)="setType('suffix')">Suffix</button>
          </div>
        </div>
        <div class="sb-fgroup">
          <div class="sb-fglabel">Sale type</div>
          <div class="sb-fopts">
            <button class="sb-fopt" [class.on]="saleType === 'new'" (click)="setSale('new')">New issue</button>
            <button class="sb-fopt" [class.on]="saleType === 'resale'" (click)="setSale('resale')">Resale</button>
          </div>
        </div>
        <div class="sb-fgroup">
          <div class="sb-fglabel">Price</div>
          <div class="sb-fopts">
            <button class="sb-fopt" [class.on]="priceBand === 'u500'" (click)="setBand('u500')">Under £500</button>
            <button class="sb-fopt" [class.on]="priceBand === 'mid'" (click)="setBand('mid')">£500–£1,000</button>
            <button class="sb-fopt" [class.on]="priceBand === 'high'" (click)="setBand('high')">£1,000–£5,000</button>
            <button class="sb-fopt" [class.on]="priceBand === 'top'" (click)="setBand('top')">£5,000+</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>

  <!-- active filter pills — only when filters are selected -->
  <div class="sb-active-filters" *ngIf="activeFilters.length">
    <button class="sb-afpill" *ngFor="let f of activeFilters" type="button"
      (click)="clearFilter(f.kind)">{{ f.label }}<span class="sb-afx" aria-hidden="true">×</span></button>
  </div>

  <!-- These sections show plates available to buy now. The exact registration
       (if held in the registry but not for sale) is still offered with Notify in
       the Perfect section above. -->
  <p class="sb-registry-note">
    Showing plates available to buy now. Can&rsquo;t see the exact one? Set a Notify alert on the
    Perfect match above and we&rsquo;ll tell you when it comes up.
  </p>

  <!-- 9. perfect plates — catalogue cards: square car image with a joined
       plate + price strip. AVAILABLE cards render first; UNAVAILABLE ones stay
       visible (the Registry holds every registration) but drop to a secondary
       treatment and read "Currently unavailable". Sits ABOVE the stacked lists. -->
  <section class="sb-perfect" *ngIf="visiblePerfectCards.length">
    <div class="pp-grid">
      <a class="pp-card" *ngFor="let c of visiblePerfectCards"
        [class.is-unavail]="!(c.reg.price > 0) && !auctionOf(c.reg)"
        href="javascript:void(0)" (click)="viewPerfect(c)">
        <div class="pp-media" [class.has-img]="c.img"
          [style.backgroundImage]="c.img ? 'url(' + c.img + ')' : null">
          <!-- At auction (live / coming soon) overrides "Currently unavailable". -->
          <span class="pp-flag pp-flag--auction" *ngIf="auctionOf(c.reg) as a; else unavailFlag"
            [class.is-soon]="a.kind === 'soon'"><i class="pp-flag-dot" aria-hidden="true"></i>{{ a.flag }}</span>
          <ng-template #unavailFlag>
            <span class="pp-flag" *ngIf="!(c.reg.price > 0)">Currently unavailable</span>
          </ng-template>
          <div class="pp-strip">
            <pla-plate class="pp-plate"
              [rawPlate]="c.reg.formattedRegistration || c.reg.registration"
              [customClass]="'flat shaded'" [plateSize]="'smaller'" [mobileSmall]="true"
              [openModal]="false" [clickThrough]="false" [showPrice]="false"
              [center]="true" [noMargin]="true"
            ></pla-plate>
            <span class="pp-price" *ngIf="auctionOf(c.reg) as a; else ppDealer">
              <ng-container *ngIf="a.value; else ppAuctionTag">
                <span class="pp-from pp-from--auction">{{ a.lead }}</span>
                <span class="pp-amount">{{ a.value }}</span>
              </ng-container>
              <ng-template #ppAuctionTag>
                <span class="pp-nolisting pp-nolisting--auction">{{ a.kind === 'soon' ? 'Coming to auction' : 'At auction' }}</span>
              </ng-template>
            </span>
            <ng-template #ppDealer>
              <span class="pp-price">
                <ng-container *ngIf="c.reg.price > 0">
                  <span class="pp-from">FROM</span>
                  <span class="pp-amount">{{ gbp(c.reg.price) }}</span>
                </ng-container>
                <span class="pp-nolisting" *ngIf="!(c.reg.price > 0)">Registry</span>
              </span>
            </ng-template>
          </div>
        </div>
        <div class="pp-body">
          <span class="pp-title">{{ perfectClass(c.reg) }}Perfect &ldquo;{{ termUpper }}&rdquo; Plate</span>
          <!-- Action wording (Save / Notify) is intentionally unchanged here — it
               will be standardised product-wide during the Plate Detail redesign. -->
          <button class="pp-act" type="button" *ngIf="c.reg.price > 0"
            (click)="$event.stopPropagation()" aria-label="Save">
            <mat-icon data-nosnippet>&#xe87e;</mat-icon>
          </button>
          <button class="pp-act pp-act--notify" type="button" *ngIf="!(c.reg.price > 0)"
            (click)="$event.stopPropagation()" aria-label="Notify">
            <mat-icon data-nosnippet>&#xe7f5;</mat-icon><span>Notify</span>
          </button>
        </div>
      </a>
    </div>
  </section>

  <!-- ============================ STACKED SECTIONS ============================
       Every typed set is stacked down the page (not swapped). The tab buttons
       above scroll to each `id="sb-sec-*"` anchor. Each list / pattern block
       paginates with "See more" so nothing renders thousands of rows at once. -->

  <!-- Close Matches — flat ranked list (search_v3). Prod-style header:
       'TERM' CLOSE MATCHES (N). The searched term is ordinary heading text;
       only wildcard arrangements ('HU??GH?') are set in the plate font. -->
  <section class="sb-sec" id="sb-sec-close">
    <header class="sb-head">
      <span class="sb-head-term">'{{ termUpper }}'</span>
      <span class="sb-head-label">Close Matches</span>
      <span class="sb-head-count" *ngIf="closeRows.length">({{ closeRows.length | number }})</span>
    </header>
    <div class="sb-table" *ngIf="closeRows.length; else closeEmpty">
      <ng-container *ngFor="let r of pageRows('close', closeRows); trackBy: trackByReg">
        <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: r }"></ng-container>
      </ng-container>
    </div>
    <button class="sb-more" type="button" *ngIf="hasMore('close', closeRows.length)"
      (click)="showMore('close', closeRows.length)">
      See more <span class="sb-more-c">showing {{ shownCount('close', closeRows.length) }} of {{ closeRows.length }}</span>
    </button>
    <ng-template #closeEmpty>
      <div class="sb-empty">
        <div class="sb-empty-t" *ngIf="loading">Searching the live market…</div>
        <div class="sb-empty-t" *ngIf="!loading">No close matches right now.</div>
      </div>
    </ng-template>
  </section>

  <!-- Similar — sound-alike / near terms (synonym). Only when populated. -->
  <section class="sb-sec" id="sb-sec-similar" *ngIf="similarRows.length">
    <header class="sb-head sb-head--sentence">
      <span class="sb-head-sentence">Similar search results to <b>{{ termUpper }}</b></span>
      <span class="sb-head-count">({{ similarRows.length | number }})</span>
    </header>
    <div class="sb-table">
      <ng-container *ngFor="let r of pageRows('similar', similarRows); trackBy: trackByReg">
        <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: r }"></ng-container>
      </ng-container>
    </div>
    <button class="sb-more" type="button" *ngIf="hasMore('similar', similarRows.length)"
      (click)="showMore('similar', similarRows.length)">
      See more <span class="sb-more-c">showing {{ shownCount('similar', similarRows.length) }} of {{ similarRows.length }}</span>
    </button>
  </section>

  <!-- New To Market — recently listed (only when populated). -->
  <section class="sb-sec" id="sb-sec-new" *ngIf="newRows.length">
    <header class="sb-head">
      <span class="sb-head-term">'{{ termUpper }}'</span>
      <span class="sb-head-label">New To Market</span>
      <span class="sb-head-count">({{ newRows.length | number }})</span>
    </header>
    <div class="sb-table">
      <ng-container *ngFor="let r of pageRows('new', newRows); trackBy: trackByReg">
        <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: r }"></ng-container>
      </ng-container>
    </div>
    <button class="sb-more" type="button" *ngIf="hasMore('new', newRows.length)"
      (click)="showMore('new', newRows.length)">
      See more <span class="sb-more-c">showing {{ shownCount('new', newRows.length) }} of {{ newRows.length }}</span>
    </button>
  </section>

  <!-- Current — wildcard pattern groups (each 'HU??GH?' style group paginated
       on its own). Replaces the old flat ~16k list. Only when populated. -->
  <section class="sb-sec" id="sb-sec-current" *ngIf="currentGroupViews.length">
    <div class="sb-group" *ngFor="let g of currentGroupViews; trackBy: trackByGroup">
      <header class="sb-head" *ngIf="g.label">
        <span class="sb-head-term sb-head-pattern">'<span class="plate-font"><ng-container *ngFor="let ch of patChars(g.label)"><span class="sb-q" *ngIf="ch === '?'">?</span><ng-container *ngIf="ch !== '?'">{{ ch }}</ng-container></ng-container></span>'</span>
        <span class="sb-head-label">Plates</span>
        <span class="sb-head-count">({{ g.count | number }})</span>
      </header>
      <div class="sb-table">
        <ng-container *ngFor="let r of pageRows(g.key, g.rows); trackBy: trackByReg">
          <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: r }"></ng-container>
        </ng-container>
      </div>
      <button class="sb-more" type="button" *ngIf="hasMore(g.key, g.loaded)"
        (click)="showMore(g.key, g.loaded)">
        See more <span class="sb-more-c">showing {{ shownCount(g.key, g.loaded) }} of {{ g.loaded }}</span>
      </button>
      <!-- backend caps each group; show the true total when we only hold a page -->
      <p class="sb-group-note" *ngIf="!hasMore(g.key, g.loaded) && g.count > g.loaded">
        Showing the top {{ g.loaded }} of {{ g.count | number }}. Refine your search to narrow these.
      </p>
    </div>
  </section>

  <!-- Prefix — wildcard pattern groups (same treatment as Current). -->
  <section class="sb-sec" id="sb-sec-prefix" *ngIf="prefixGroupViews.length">
    <div class="sb-group" *ngFor="let g of prefixGroupViews; trackBy: trackByGroup">
      <header class="sb-head" *ngIf="g.label">
        <span class="sb-head-term sb-head-pattern">'<span class="plate-font"><ng-container *ngFor="let ch of patChars(g.label)"><span class="sb-q" *ngIf="ch === '?'">?</span><ng-container *ngIf="ch !== '?'">{{ ch }}</ng-container></ng-container></span>'</span>
        <span class="sb-head-label">Plates</span>
        <span class="sb-head-count">({{ g.count | number }})</span>
      </header>
      <div class="sb-table">
        <ng-container *ngFor="let r of pageRows(g.key, g.rows); trackBy: trackByReg">
          <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: r }"></ng-container>
        </ng-container>
      </div>
      <button class="sb-more" type="button" *ngIf="hasMore(g.key, g.loaded)"
        (click)="showMore(g.key, g.loaded)">
        See more <span class="sb-more-c">showing {{ shownCount(g.key, g.loaded) }} of {{ g.loaded }}</span>
      </button>
      <p class="sb-group-note" *ngIf="!hasMore(g.key, g.loaded) && g.count > g.loaded">
        Showing the top {{ g.loaded }} of {{ g.count | number }}. Refine your search to narrow these.
      </p>
    </div>
  </section>

  </ng-container>

  <!-- Market Performance — a REAL content-swap tab (not stacked): selecting the
       tab hides the result sections above and shows this panel in their place. -->
  <section class="sb-sec sb-sec--market" id="sb-sec-market" *ngIf="activeTab === 'market'">
    <header class="sb-head">
      <span class="sb-head-term">'{{ termUpper }}'</span>
      <span class="sb-head-label">Market Performance</span>
    </header>
    <div class="sb-empty sb-empty--tab">
      <div class="sb-empty-t">Market performance &amp; recent sales are coming to search</div>
    </div>
  </section>

  <!-- Shared result-row markup — one definition used by every stacked section.
       Same columns as the site-wide result row (search-result-row / under-£200):
       plate · Save (Notify when not listed) · Plate Viewer · price · View.
       The action components handle their own clicks, so they stop the row's
       navigation from firing underneath them. -->
  <ng-template #rowTpl let-r>
    <div class="sb-row" role="link" tabindex="0" [@rowAnim] [attr.data-reg]="r.registration"
      [class.is-unavail]="!(r.price > 0) && !auctionOf(r)"
      [class.is-auction]="!!auctionOf(r)" (click)="view(r)" (keydown.enter)="view(r)">
      <span class="sb-r-plate">
        <pla-plate
          [rawPlate]="r.formattedRegistration || r.registration"
          [customClass]="'flat shaded'" [plateSize]="'smaller'" [mobileSmall]="true"
          [openModal]="false" [clickThrough]="false" [showPrice]="false"
          [center]="true" [noMargin]="true"
        ></pla-plate>
      </span>
      <span class="sb-r-act" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
        <pla-inline-favourite [plate]="r"></pla-inline-favourite>
      </span>
      <span class="sb-r-act sb-r-act--viewer" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
        <pla-inline-plate-viewer-link [plate]="r"></pla-inline-plate-viewer-link>
      </span>
      <!-- Price column. An auction (live / coming soon) is shown INSTEAD of
           the dealer price; market depth ("Compare N sellers") sits beneath. -->
      <span class="sb-r-pricecol" *ngIf="auctionOf(r) as a; else dealerPrice">
        <span class="sb-r-price sb-r-price--auction"><span class="sb-r-from">{{ a.lead }}</span>{{ a.value }}</span>
        <span class="sb-r-sub sb-r-auction" [class.is-soon]="a.kind === 'soon'"><i class="sb-r-dot" aria-hidden="true"></i>{{ a.status }} · {{ a.lot.houseName }}</span>
      </span>
      <ng-template #dealerPrice>
        <span class="sb-r-pricecol">
          <ng-container *ngIf="r.price > 0; else notListed">
            <span class="sb-r-price"><span class="sb-r-from">from</span>{{ gbp(r.price) }}</span>
            <span class="sb-r-sub" *ngIf="compareLabel(r)">{{ compareLabel(r) }}</span>
          </ng-container>
          <ng-template #notListed><span class="sb-r-unavail">Not available</span></ng-template>
        </span>
      </ng-template>
      <span class="sb-r-view" aria-hidden="true">View</span>
      <span class="sb-r-chev" aria-hidden="true"><mat-icon data-nosnippet>&#xe5cc;</mat-icon></span>
    </div>
  </ng-template>
</div>
